import __vue_component__$2 from '../Select/Select.vue.js';
import pDebounce_1 from '../../node_modules/p-debounce/index.js';
import __vue_component__ from './UserRenderer.vue.js';
import __vue_component__$1 from '../Form/InlineEdit.vue.js';

//
var script = {
  name: 'UserEditableRenderer',
  components: {
    UserRenderer: __vue_component__,
    InlineEdit: __vue_component__$1,
    Select: __vue_component__$2
  },
  props: {
    user: {
      type: Object,
      default: undefined
    },
    editable: {
      type: Boolean,
      default: true
    },
    placement: {
      type: String,
      default: 'right'
    },
    avatarOnly: {
      type: Boolean,
      default: false
    },
    loadOptions: {
      type: Function,
      required: true
    },
    tag: {
      type: String,
      default: 'span'
    },
    mapper: {
      type: Function,
      default: list => list
    },
    initialOptions: {
      type: Array,
      default: () => []
    },
    clearable: {
      type: Boolean,
      default: true
    },
    confirm: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      users: [],
      isFetching: false,
      debouncedGetUsers: undefined
    };
  },

  created() {
    this.debouncedGetUsers = pDebounce_1(this.onSearchChange, 200);
  },

  methods: {
    async onSearchChange(query) {
      this.isFetching = true;
      const {
        data: users
      } = await this.loadOptions(query);
      this.users = this.mapper(users);
      this.isFetching = false;
    },

    onSaveRequested(user, callback) {
      this.$emit('save-requested', user, callback);
    },

    normalizer(user) {
      return {
        id: user && user.key,
        label: user && user.name,
        value: user
      };
    },

    loadInitialOptions() {
      this.users = this.initialOptions;
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/field-renderers/UserEditableRenderer.vue_rollup-plugin-vue=script.js